var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-panel"},[_c('StatsCard'),_c('div',{staticClass:"map-card"},[_c('MapDrillDown')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }